import Vue from 'vue';
import * as d3 from 'd3';
import CalculatePreviewHighlightDensity from '../../util/density/CalculatePreviewHighlightDensity';
import calculateKLDivergence from '../../util/density/KLDivergence';
import truncateMatrixAndCalcPreviewDensity from '../../util/density/truncateMatrixAndCalcPreviewDensity';



const processNonHighlightOwningNode = (nodeUUID) => {

  /* 
    This function expects the nodeUUID as parameter.
    This function is supposed to only process nodes that are not highlight-owners; the highlight-owning node needs to be ignored.
    In the first part, this function generates the density preview for its node.
    In a second part, this function generates the highlight density preview if there is a highlight defined in the current model.
    If there is no highlight defined at all, this needs to be detected and no highlight will be computed.
  */

  // If we have the necessary data for the node itself
  if ( (Vue.prototype.$globalSharedData.globalNodeData[nodeUUID]) && (Vue.prototype.$globalSharedData.globalNodeData[nodeUUID].data)){
    
    let nodeID = Vue.prototype.$globalSharedData.globalNodeData[nodeUUID].nodeID;
    let matrix = Vue.prototype.$globalSharedData.globalNodeData[nodeUUID].data;
    let nodeFunction = Vue.prototype.$globalSharedData.globalNodeData[nodeUUID].nodeFunction;
    let nodeNameForDriverList = Vue.prototype.$globalSharedData.globalNodeData[nodeUUID].name;

    
    // If we do not have a highlight-owning node, then stop here and only return density preview but no highlight density
    if (typeof Vue.prototype.$globalSharedData.idOfNodeThatOwnsHighlight == "undefined"){

      // If there is no highlight-owner
      // Then all the previews of ALL nodes can be updated here
      // Then do not create highlight, just update the normal paths
      // Only do so IF there is actually nodeData; otherwise do nothing for this node

      // Truncate matrix and calculate preview density
      let previewDensityResults = truncateMatrixAndCalcPreviewDensity(matrix);

      let data = {

        nodeID: nodeID,
        nodeUUID: nodeUUID,
        pathvalues: previewDensityResults.pathvalues,
        density: previewDensityResults.density,
        matrixTruncatedForPreview: previewDensityResults.matrixTruncatedForPreview,
        canPreviewBeShown: previewDensityResults.canPreviewBeShown,
        previewMessage: previewDensityResults.previewMessage,
        
        // All things related to highlights are now undefined
        thisNodeIsHighlightOwner: false,
        highlightvalues: undefined,
        highlightLine: undefined,
        highlightDensity: undefined,
        klDivergence: undefined,

      }

      // Update the dist preview of the highlight-owning node
      Vue.prototype.$eventHub.$emit("DistPreviewPleaseUpdate", data);
    
    } else {

      // Case that we do have a highlight-owning node, then we calculate highlights
      // But only for those nodes that are NOT highlight-owning

      if (nodeID != Vue.prototype.$globalSharedData.idOfNodeThatOwnsHighlight){

        // Truncate matrix and calculate preview density
        let previewDensityResults = truncateMatrixAndCalcPreviewDensity(matrix);

        let matrixTruncatedForPreview = previewDensityResults.matrixTruncatedForPreview;
        let yDensity = previewDensityResults.yDensity;

        // If we have a global highlight array and it is non-empty
        if ((Vue.prototype.$globalHighlightArray) && (Vue.prototype.$globalHighlightArray.length > 0 )){

          let klDivergence;

          // Create the values for the highlight density
          let highlightResults = CalculatePreviewHighlightDensity(matrixTruncatedForPreview[Vue.prototype.$globalSharedData.selectedPeriod]);
  
          let yDensityHighlight = highlightResults.yDensity; // this is a one-dim array of the y values of the density (before adding values at the start/end)
  
          // console.log('yDensityHighlight ' + this.nodeID, yDensityHighlight)
  
          let densityHighlight = highlightResults.density; // array of arrays
  
          // Create the line from the values
          let highlightLine = d3.line()(densityHighlight);
  
          if(typeof yDensityHighlight[0] != 'undefined'){
            // we cannot calulate KL Divergence if we open a node without a highlight (yDensityHighlight consists of 'undefined' entries)
  
            // Replace all values in the densityHighlight that are zero by a very small non-zero value
            // This is because KL divergence is undefined if q_i=0 and p_i>0.
            let yDensityHighlightAboveZero = [...yDensityHighlight];
            for (let i = 0; i < yDensityHighlightAboveZero.length; i++){
              if (yDensityHighlightAboveZero[i] == 0){
                yDensityHighlightAboveZero[i] = 1 * Math.pow(10, -10); // 1 * 10^-10
              }
            }
  
            if ((yDensity) && (yDensity.length > 1)){
  
              // In case of add nodes that add single values, the length can be just one, with a zero valued element
              // Then KL Divergence calculation would fail
              // So, in those cases we allow the KL Divergence to be undefined
              
              klDivergence = calculateKLDivergence(yDensity, yDensityHighlightAboveZero);
              // console.log('yDensity VueDistPreview ' + this.nodeID, yDensity)
              // console.log('yDensityHighlight', yDensityHighlight)
              // console.log('yDensityHighlightAboveZero VueDistPreview ' + this.nodeID, yDensityHighlightAboveZero)
  
              if (Number.isNaN(klDivergence)){
                console.log('We might have a problem -- the KL Divergence is NaN');
                console.log('yDensity', yDensity);
                console.log('yDensityHighlightAboveZero', yDensityHighlightAboveZero);
              }
  
            }
  
            // console.log('KLDivergence VueDistPreview ' + this.nodeID, klDivergence)
  
            Vue.prototype.$globalSharedData.klDivergenceArray.push({
              nodeID: nodeID,
              nodeUUID: nodeUUID,
              nodeNameForDriverList: nodeNameForDriverList,
              nodeFunction: nodeFunction,
              KLDivergence: klDivergence
            });
  
            // Update the VueDistPreview
  
            let data = {
  
              nodeID: nodeID,
              nodeUUID: nodeUUID,
              thisNodeIsHighlightOwner: false,
              pathvalues: previewDensityResults.pathvalues,
              density: previewDensityResults.density,
              highlightvalues: undefined,
              highlightLine: highlightLine,
              highlightDensity: densityHighlight,
              matrixTruncatedForPreview: previewDensityResults.matrixTruncatedForPreview,
              klDivergence: klDivergence,
              canPreviewBeShown: previewDensityResults.canPreviewBeShown,
              previewMessage: previewDensityResults.previewMessage
  
            }
  
            // Update the dist preview
            Vue.prototype.$eventHub.$emit("DistPreviewPleaseUpdate", data);
          }
        }

      }

    } 

  }

}

export default processNonHighlightOwningNode;